
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'
import Phase1Screen from '../../Mars/Phases/Phase1Screen/Phase1Screen'

import * as tutorialSelectors from '../tutorial.selectors'
import * as tutorialActions from '../tutorial.actions'
// import * as tutorialConstants from "../tutorial.constants"

const mapStateToProps = (state) => ({
  disputesInfo: () => console.log('disputesInfo'), //activitySelectors.getDisputesInfo(state),
  battlesInfo: [], //activitySelectors.getBattlesInfo(state),
  totalLikes: () => console.log('totalLikes'), //miningSelectors.getTotalLikes(state),
  MISInfo: tutorialSelectors.getMISInfo(state),

  debatesInfo: tutorialSelectors.getDebatesInfo(state),
  rivalInfo: tutorialSelectors.getRivalInfo(state),
  currentUser: tutorialSelectors.getUserData(state),
  indicators: tutorialSelectors.getUserData(state),
  playersList: tutorialSelectors.getPlayerList(state),
  relativeTurn: ((tutorialSelectors.getTurn(state) + 1) % 2) + 1,
  groupData: tutorialSelectors.getGroupData(state),
  hideTabs: tutorialSelectors.getPhase1HideUI(state),
})

const mapDispatchToProps = (dispatch) => ({
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  nextPhase: bindActionCreators(tutorialActions.nextPhase, dispatch),
  loadEvent: bindActionCreators(tutorialActions.noop, dispatch),
  loadActivity: bindActionCreators(tutorialActions.noop, dispatch),
  addScreen: bindActionCreators(tutorialActions.addScreen, dispatch),
  triggerSelectTab: bindActionCreators(tutorialActions.triggerSelectTab, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Phase1Screen))
